// extracted by mini-css-extract-plugin
module.exports = {"language":"styles_language__3ad4H","languageMenuItem":"styles_languageMenuItem__hfYPG","icon":"styles_icon__P1U39"};